import axios, { AxiosPromise } from 'axios';

import { IInspectionPoint } from '../../../@types/model/masterData/inspectionPoint/inspectionPoint';

export default class InspectionPointHttpService {
    public static getInspectionPointData() : AxiosPromise<Array<IInspectionPoint>> {
        return axios.get(`${API_URL}/v1/InspectionPoint/GetAllWeb`);
    }

    public static addOrUpdateInspectionPoint(data : IInspectionPoint) : AxiosPromise<IInspectionPoint> {
        return axios.post(`${API_URL}/v1/InspectionPoint/PostInspectionPoint`, data);
    }

    public static deleteInspectionPoint(inspectionPointId : number) : AxiosPromise<IInspectionPoint> {
        return axios.delete(`${API_URL}/v1/InspectionPoint/Delete`, {
            params : { inspectionPointId },
        });
    }
}
